<template>
  <div class="member" style="width: 100%" >
    <div class="member-content" >
      <div class="member-head-title">
        现有成员
        <a-row style="width: 90%; height: 100%" class="member-table-head">
          <a-col :offset="16" :span="5"
            ><a-input-search
              placeholder="请输入查询的成员名字"
              style="width: 294px"
              @search="onSearch"
          /></a-col>
          <a-col :offset="1" :span="2">
            <a-select
              default-value="名字、升序"
              style="width: 120px;"
              @change="handleChange"
            >
              <a-select-option value="asc"> 名字、升序 </a-select-option>
              <a-select-option value="desc"> 名字、降序 </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
      <div class="member-table">
        <a-table :columns="columns" :data-source="memberList" :pagination="false">
          <a slot="name" slot-scope="text">{{ text }}</a>
          <template slot="userAvatar" slot-scope="text, record">
            <img
              :src="record.userAvatar"
              alt="加载异常"
              style="width: 48px; height: 48px; border-radius: 24px"
            />
          </template>
          <template slot="action" slot-scope="text, record">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="changeIndentity(record)">
                编辑 <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;">仅查看</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;">可编辑</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="del(record.id)">移除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import global_ from "@/utils/global.js";
const columns = [
  {
    title: "头像",
    dataIndex: "userAvatar",
    scopedSlots: { customRender: "userAvatar" },
    width: 250,
  },
  {
    title: "姓名",
    dataIndex: "userRealname",
    width: 200,
  },
  {
    title: "身份",
    dataIndex: "roleType",
    width: 600,
    align: "left",
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name:'Member',
  data() {
    return {
      columns,
    };
  },
  props: {
    memberList:{
      type:Array,
    }
  },
  methods: {
    onSearch(value) {
      this.$emit('onSearch',value)
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    handleChange(value) {
      this.$emit('handleChange',value)
    },
    changeIndentity(record){
      // console.log(record)
    },
    del(id) {
      this.$emit('del',id)
    }
  },
};
</script>
<style scoped>
@import "./index.css";
</style>